/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MedPillsIcon16Light } from './MedPillsIcon16Light';
import { MedPillsIcon16Regular } from './MedPillsIcon16Regular';
import { MedPillsIcon16Solid } from './MedPillsIcon16Solid';
import { MedPillsIcon20Light } from './MedPillsIcon20Light';
import { MedPillsIcon20Regular } from './MedPillsIcon20Regular';
import { MedPillsIcon20Solid } from './MedPillsIcon20Solid';
import { MedPillsIcon24Regular } from './MedPillsIcon24Regular';
import { MedPillsIcon24Solid } from './MedPillsIcon24Solid';
import { MedPillsIcon32Regular } from './MedPillsIcon32Regular';
import { MedPillsIcon64Regular } from './MedPillsIcon64Regular';
var sizes = {
    16: {
        light: MedPillsIcon16Light,
        regular: MedPillsIcon16Regular,
        solid: MedPillsIcon16Solid,
    },
    20: {
        light: MedPillsIcon20Light,
        regular: MedPillsIcon20Regular,
        solid: MedPillsIcon20Solid,
    },
    24: {
        regular: MedPillsIcon24Regular,
        solid: MedPillsIcon24Solid,
    },
    32: {
        regular: MedPillsIcon32Regular,
    },
    64: {
        regular: MedPillsIcon64Regular,
    },
};
export var MedPillsIcon = forwardRef('MedPillsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
